import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import NotificationContainer from './components/NotificationContainer';
import CourtAdminLayout from './layouts/CourtAdminLayout';
import SuperAdminLayout from './layouts/SuperAdminLayout';
import RegistrarLayout from './layouts/RegistrarLayout';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ChangePassword from './pages/ChangePassword';
import Dashboard from './pages/Dashboard';
import Transcriptions from './pages/Transcriptions';
import TranscriptionDetail from './pages/TranscriptionDetail';
import CourtCases from './pages/CourtCases';
import CourtCaseDetail from './pages/CourtCaseDetail';
import Sessions from './pages/Sessions';
import Regenerations from './pages/Regenerations';
import Profile from './pages/Profile';
import Billing from './pages/Billing';
import Unauthorized from './pages/Unauthorized';
import CourtAdminDashboard from './pages/admin/CourtAdminDashboard';
import AdminSessions from './pages/admin/AdminSessions';
import AdminTranscriptions from './pages/admin/AdminTranscriptions';
import AdminRegenerationReport from './pages/admin/AdminRegenerationReport';
import AdminAuditLog from './pages/admin/AdminAuditLog';
import AdminSettings from './pages/admin/AdminSettings';
import AdminAccountSettings from './pages/admin/AdminAccountSettings';
import AdminCertification from './pages/admin/AdminCertification';
import AdminTranscriptionDetail from './pages/admin/AdminTranscriptionDetail';
import SuperAdminDashboard from './pages/super-admin/SuperAdminDashboard';
import SuperAdminAccountSettings from './pages/super-admin/SuperAdminAccountSettings';
import SuperAdminTenants from './pages/super-admin/SuperAdminTenants';
import SuperAdminRegeneration from './pages/super-admin/SuperAdminRegeneration';
import SuperAdminAuditLog from './pages/super-admin/SuperAdminAuditLog';
import SuperAdminSettings from './pages/super-admin/SuperAdminSettings';
import './index.css';

function App() {
  return (
    <Router>
      <ThemeProvider>
      <AuthProvider>
        <NotificationProvider>
          <div className="App">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route
                path="/change-password"
                element={
                  <ProtectedRoute>
                    <ChangePassword />
                  </ProtectedRoute>
                }
              />
              <Route path="/unauthorized" element={<Unauthorized />} />

              <Route
                element={
                  <ProtectedRoute>
                    <RegistrarLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/sessions" element={<Sessions />} />
                <Route path="/transcriptions" element={<Transcriptions />} />
                <Route path="/transcriptions/:id" element={<TranscriptionDetail />} />
                <Route path="/court-cases" element={<CourtCases />} />
                <Route path="/court-cases/:id" element={<CourtCaseDetail />} />
                <Route path="/regenerations" element={<Regenerations />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/account-settings" element={<Profile />} />
                <Route path="/billing" element={<Billing />} />
              </Route>

              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <RoleProtectedRoute allowedRoles={['court_admin', 'super_admin']}>
                      <CourtAdminLayout />
                    </RoleProtectedRoute>
                  </ProtectedRoute>
                }
              >
                <Route index element={<CourtAdminDashboard />} />
                <Route path="sessions" element={<AdminSessions />} />
                <Route path="transcriptions" element={<AdminTranscriptions />} />
                <Route path="transcriptions/:id" element={<AdminTranscriptionDetail />} />
                <Route path="certification" element={<AdminCertification />} />
                <Route path="regeneration" element={<AdminRegenerationReport />} />
                <Route path="audit-log" element={<AdminAuditLog />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="account-settings" element={<AdminAccountSettings />} />
              </Route>

              <Route
                path="/super-admin"
                element={
                  <ProtectedRoute>
                    <RoleProtectedRoute allowedRoles={['super_admin']}>
                      <SuperAdminLayout />
                    </RoleProtectedRoute>
                  </ProtectedRoute>
                }
              >
                <Route index element={<SuperAdminDashboard />} />
                <Route path="tenants" element={<SuperAdminTenants />} />
                <Route path="regeneration" element={<SuperAdminRegeneration />} />
                <Route path="audit-log" element={<SuperAdminAuditLog />} />
                <Route path="settings" element={<SuperAdminSettings />} />
                <Route path="account-settings" element={<SuperAdminAccountSettings />} />
              </Route>
            </Routes>

            <NotificationContainer />

            <Toaster
              position="top-right"
              richColors
              closeButton
              duration={4000}
              theme="light"
            />
          </div>
        </NotificationProvider>
      </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
